// api
export const API_URI = process.env.REACT_APP_API_URL;
export const STATIC_SITE_URI = process.env.REACT_APP_STATIC_SITE_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
